// @oasis-permission-inherits: /capcode (capcode:view)
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/capcode/conversations")({
  component: Outlet,
});
